import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { Observable } from "rxjs";
import { ConfigService } from "../../shared/services/config.service";
import { UserService } from "../../shared/services/user.service";

@Injectable({
    providedIn: "root"
  })
  
export class ForecastService extends ApiBaseService {
    constructor(private configService: ConfigService, private http: HttpClient, private us: UserService) {
      super(us);
      this.httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", SessionId: this.userService.sessionId, 'APIKEY': 'ams-direct-api-production-key', }) };
      this.baseUrl = `${this.configService.config.productionUrl}/api/forecast`;
    }

    getOrder(id: number): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/getOrder/` + id, this.httpOptions);
    }

    getWMSArticle(id: number): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/getWMSArticle/` + id, this.httpOptions);
    }

    getWMSArticles(wmsArticleGroupId: number) : Observable<any> {
      return this.http.get<any>(`${this.baseUrl}/getWMSArticles?wmsArticleGroupId=` + wmsArticleGroupId, this.httpOptions);
    }

    getWMSArticleGroups() : Observable<any> {
      return this.http.get<any>(`${this.baseUrl}/getWMSArticleGroups/`, this.httpOptions)
      .pipe(catchError(this.handleError<boolean>(`Failed to get articlegroups`)));
    }

    postWMSArticle(rec: any): Observable<any> {
      return this.http.post<any>(`${this.baseUrl}/AddWMSArticle`, rec, this.httpOptions);
    }

    putWMSArticle(updateWMSArticle: any): Observable<any> {
      return this.http.put<any>(`${this.baseUrl}/UpdateWMSArticle`, updateWMSArticle, this.httpOptions);
    }

    deleteArticle(id: any): Observable<any> {
        return this.http.delete<any>(`${this.baseUrl}/DeleteWMSArticle?id=` + id, this.httpOptions);
    }
  
    getSalesForecast(year: number): Observable<any> {
      
        return this.http.get<any>(`${this.baseUrl}/GetSalesForecast?year=${year}`, this.httpOptions)
                                .pipe(catchError(this.handleError<boolean>(`Failed to get orders`)));
    }
  
    getOrderForecast(wmsArticleId: number, year: number): Observable<any> {
      
        return this.http.get<any>(`${this.baseUrl}/getOrderForecast?wmsArticleId=${wmsArticleId}&year=${year}`, this.httpOptions)
                                .pipe(catchError(this.handleError<boolean>(`Failed to get forecast`)));
    }

    postOrderForecast(rec: any): Observable<any> {
      return this.http.post<any>(`${this.baseUrl}/AddOrderForecast`, rec, this.httpOptions);
    }

    putOrderForecast(rec: any): Observable<any> {
      return this.http.put<any>(`${this.baseUrl}/UpdateOrderForecast`, rec, this.httpOptions);
    }

    deleteOrder(wmsArticleId: number, id: any): Observable<any> {
        return this.http.delete<any>(`${this.baseUrl}/DeleteOrder?wmsArticleId=${wmsArticleId}&orderId=` + id, this.httpOptions);
    }
  
    getHistoryOrders(wmsArticleId: number, year: number): Observable<any> {
      
        return this.http.get<any>(`${this.baseUrl}/GetHistoryOrders?wmsArticleId=${wmsArticleId}&year=${year}`, this.httpOptions)
                                .pipe(catchError(this.handleError<boolean>(`Failed to get history`)));
    }
}
